import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import { TextField } from "@/shared/components/Form/TextField";
import { AutocompleteField } from "@/shared/components/Form/AutocompleteField";
import { ColorPickerField } from "@/shared/components/Form/ColorPickerField";
import type {
  PlatformBlockComponent,
  PlatformBlockProps,
} from "../../../types";
import { Paper } from "@mui/material";
import { BlockFormHeader } from "../BlockFormHeader";

const variantOptions = [
  { value: "h1", label: "h1" },
  { value: "h2", label: "h2" },
  { value: "h3", label: "h3" },
  { value: "h4", label: "h4" },
  { value: "h5", label: "h5" },
  { value: "h6", label: "h6" },
  { value: "subtitle1", label: "subtitle1" },
  { value: "subtitle2", label: "subtitle2" },
  { value: "body1", label: "body1" },
  { value: "body2", label: "body2" },
  { value: "caption", label: "caption" },
];

const colorValues = [
  "primary",
  "secondary",
  "textPrimary",
  "textSecondary",
] as const;

const alignValues = ["left", "center", "right", "justify"] as const;

export const Text: PlatformBlockComponent = ({ name }: PlatformBlockProps) => {
  const { t } = useTranslation();

  const colorOptions = colorValues.map((value) => ({
    value,
    label: t(`platformBlocks.textColor.${value}`),
  }));

  const alignOptions = alignValues.map((value) => ({
    value,
    label: t(`platformBlocks.align.${value}`),
  }));

  return (
    <Paper sx={{ p: 2 }}>
      <BlockFormHeader blockType="TEXT" />
      <Grid container spacing={2}>
        <Grid size={12}>
          <TextField
            name={`${name}.text`}
            label={t("platformBlocks.fields.text")}
            type="text"
            multiline
            fullWidth
          />
        </Grid>
        <Grid size={6}>
          <AutocompleteField
            name={`${name}.variant`}
            label={t("platformBlocks.fields.variant")}
            fullWidth
            options={variantOptions}
          />
        </Grid>
        <Grid size={6}>
          <AutocompleteField
            name={`${name}.color`}
            label={t("platformBlocks.fields.color")}
            fullWidth
            options={colorOptions}
          />
        </Grid>
        <Grid size={4}>
          <AutocompleteField
            name={`${name}.align`}
            label={t("platformBlocks.fields.align")}
            fullWidth
            options={alignOptions}
          />
        </Grid>
        <Grid size={4}>
          <TextField
            name={`${name}.paddingTop`}
            label={t("platformBlocks.fields.paddingTop")}
            type="number"
            fullWidth
          />
        </Grid>
        <Grid size={4}>
          <TextField
            name={`${name}.paddingBottom`}
            label={t("platformBlocks.fields.paddingBottom")}
            type="number"
            fullWidth
          />
        </Grid>
        <Grid size={6}>
          <TextField
            name={`${name}.maxWidth`}
            label={t("platformBlocks.fields.maxWidth")}
            type="number"
            fullWidth
          />
        </Grid>
        <Grid size={6}>
          <ColorPickerField
            name={`${name}.backgroundColor`}
            label={t("platformBlocks.fields.backgroundColor")}
            fullWidth
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
